/* StyleMechanics Globe.GL overlays: real boundaries + Brooklyn home + privacy-safe shared activity. */
(function(){
  if(window.__smTruthfulGlobeOverlayV9)return;
  window.__smTruthfulGlobeOverlayV9=true;

  var HOME={lat:40.6782,lng:-73.9442};
  var API='https://live-activity-api-s8s9-production.up.railway.app';
  function ownerMode(){
    /* Preview/editor visits are excluded only for that page, not forever on this browser. */
    try{
      var shopify=window.Shopify||{},theme=shopify.theme||{};
      var preview=!!shopify.designMode||!!(theme&&theme.role&&theme.role!=='main')||/preview_theme_id|_fd=0|pb=0/.test(location.search);
      if(!preview){try{localStorage.removeItem('sm_owner_mode')}catch(e){}}
      return preview;
    }catch(e){return /preview_theme_id|_fd=0|pb=0/.test(location.search)}
  }
  var WORLD='https://cdn.jsdelivr.net/gh/holtzy/D3-graph-gallery@master/DATA/world.geojson';
  var ADMIN='https://cdn.jsdelivr.net/gh/nvkelso/natural-earth-vector@master/geojson/ne_50m_admin_1_states_provinces.geojson';
  var COAST='https://cdn.jsdelivr.net/gh/nvkelso/natural-earth-vector@master/geojson/ne_110m_coastline.geojson';
  var cache={};

  function load(url){
    if(cache[url])return cache[url];
    cache[url]=fetch(url,{mode:'cors'}).then(function(r){if(!r.ok)throw new Error('boundary');return r.json()}).catch(function(){return{features:[]}});
    return cache[url];
  }
  function rgba(hex,a){
    hex=(hex||'#2bf3f5').replace('#','');
    if(hex.length===3)hex=hex.replace(/(.)/g,'$1$1');
    var n=parseInt(hex,16)||0;
    return 'rgba('+((n>>16)&255)+','+((n>>8)&255)+','+(n&255)+','+Math.max(0,Math.min(1,a))+')';
  }
  function mark(fs,t){return(fs||[]).map(function(f){f.__smLayer=t;return f})}
  function paths(fs){
    var out=[];
    (fs||[]).forEach(function(f){var g=f&&f.geometry;if(!g)return;var c=g.coordinates||[];
      if(g.type==='LineString')out.push({points:c});
      else if(g.type==='MultiLineString'||g.type==='Polygon')c.forEach(function(x){out.push({points:x})});
      else if(g.type==='MultiPolygon')c.forEach(function(p){p.forEach(function(x){out.push({points:x})})});
    });
    return out;
  }
  function settings(root){
    var o=Object.assign({},window.__smMapAccentSettings||{});
    var c=window.__smGlobeColorSettings||{};
    var cs=getComputedStyle(root);
    o.aqua='#00F6FF';
    o.purple='#FF2BD6';
    o.landColor='#120B0B';
    o.waterColor='#6A1418';
    o.heatLow='#FFD54A';
    o.heatMid='#FFB000';
    o.heatHigh='#FF6A00';
    o.heatHot='#FF2A2A';
    o.countryOutlineOpacity=.30;
    o.admin1Opacity=.38;
    o.countryLift=.006;
    o.admin1Lift=.009;
    return o;
  }

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(ch){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]})}
  function countryName(code){
    if(!code)return'';
    try{if(window.Intl&&Intl.DisplayNames)return new Intl.DisplayNames([document.documentElement.lang||'en'],{type:'region'}).of(String(code).toUpperCase())||String(code).toUpperCase()}catch(e){}
    return String(code).toUpperCase();
  }
  function locationLabel(loc){
    loc=loc||{};
    var parts=[loc.city,loc.region,countryName(loc.country)],out=[];
    parts.forEach(function(x){x=(x||'').trim();if(!x)return;if(!out.some(function(y){return y.toLowerCase()===x.toLowerCase()}))out.push(x)});
    return out.join(', ')||'Visitor';
  }
  function eventMeta(v,state){
    return state==='active'
      ?{key:'active',color:'#00F6FF'}
      :{key:'recent',color:'#FF2BD6'};
  }
  function currentViewLabel(){
    var path=(location.pathname||'/').replace(/\/+$/,'')||'/';
    var h=document.querySelector('main h1,[role="main"] h1,h1');
    var title=(h&&h.textContent||document.querySelector('meta[property="og:title"]')&&document.querySelector('meta[property="og:title"]').content||document.title||'').replace(/\s+/g,' ').trim();
    title=title.replace(/\s*[|–—-]\s*StyleMechanics.*$/i,'').trim();
    if(path==='/')return'Viewing Home';
    if(/^\/products\//.test(path))return'Viewing product'+(title?' • '+title:'');
    if(/^\/collections\//.test(path))return'Viewing collection'+(title?' • '+title:'');
    if(path==='/pages/live-stickers'||path==='/pages/live-stickers/')return'Building Custom Stickers';
    if(path==='/cart')return'Viewing Cart';
    return'Viewing'+(title?' • '+title:' page');
  }

  function forceGlobalLabels(root){
    var market=root.querySelector('[data-sm-market]');
    if(market){market.textContent='GLOBAL';if(market.nextSibling&&market.nextSibling.nodeType===3)market.nextSibling.nodeValue=' MARKET'}
    var marketName=root.querySelector('[data-sm-market-name]');
    if(marketName){marketName.textContent='WORLDWIDE';if(marketName.nextElementSibling)marketName.nextElementSibling.textContent='GLOBAL MARKET'}
    var small=root.querySelector('.sm-world-live__counter small');
    if(small)small.textContent='LIVE GLOBAL ACTIVITY';
  }
  function applyStarSetting(root,g){
    try{if(root.classList.contains('sm-world-live--no-stars')&&typeof g.backgroundImageUrl==='function')g.backgroundImageUrl(null)}catch(e){}
  }

  function pointAccessors(g){
    if(document.querySelector('[data-sm-world-live].sm-bb-active'))return;
    try{
      g.pointLat('lat').pointLng('lng').pointColor(function(p){return p.color||'#20F4F7'}).pointRadius(function(p){return p.radius||.08}).pointAltitude(function(p){return p.altitude||.01});
      if(typeof g.pointLabel==='function')g.pointLabel(function(p){return p.label||''});
    }catch(e){}
  }
  function mergePoint(g,item){
    if(document.querySelector('[data-sm-world-live].sm-bb-active'))return;
    var pts=[];try{pts=g.pointsData()||[]}catch(e){}
    pts=pts.filter(function(p){return !(p&&p.__smKind===item.__smKind)});pts.push(item);pointAccessors(g);try{g.pointsData(pts)}catch(e){}
  }
  function removePointKind(g,kind){
    if(document.querySelector('[data-sm-world-live].sm-bb-active'))return [];
    var pts=[];try{pts=g.pointsData()||[]}catch(e){}
    pts=pts.filter(function(p){return !(p&&p.__smKind===kind)});pointAccessors(g);try{g.pointsData(pts)}catch(e){}return pts;
  }
  function removeRingKind(g,kind){
    if(document.querySelector('[data-sm-world-live].sm-bb-active'))return [];
    var rings=[];try{rings=g.ringsData()||[]}catch(e){}
    rings=rings.filter(function(r){return !(r&&r.__smKind===kind)});try{g.ringsData(rings)}catch(e){}return rings;
  }
  function mergeRing(g,item){
    var rings=removeRingKind(g,item.__smKind);rings.push(item);
    try{g.ringLat('lat').ringLng('lng').ringAltitude(function(r){return typeof r.altitude==='number'?r.altitude:.02}).ringColor(function(r){return r.color||'#2bf3f5'}).ringMaxRadius(function(r){return r.maxRadius||1.2}).ringPropagationSpeed(function(r){return r.speed||.35}).ringRepeatPeriod(function(r){return typeof r.repeat==='number'?r.repeat:2600}).ringsData(rings)}catch(e){}
  }

  /* Decorative network markers: geographic points, never visits or feed entries. */
  function installAmbientNetwork(root){
    if(root.__smAmbientCleanup)root.__smAmbientCleanup();
    var stopped=false,cycleTimer=null,expiryTimers=[],current=[],counter=0;
    var land=[
      [39.74,-104.99],[41.88,-87.63],[39.10,-94.58],[35.47,-97.52],
      [33.45,-112.07],[32.78,-96.80],[36.17,-115.14],[40.76,-111.89],
      [38.58,-121.49],[39.96,-83.00],[35.15,-90.05],[33.75,-84.39],
      [43.65,-79.38],[45.50,-73.57],[49.25,-123.12],[51.05,-114.07],
      [19.43,-99.13],[20.67,-103.35],[-23.55,-46.63],[-19.92,-43.94],
      [-34.60,-58.38],[-33.45,-70.67],[4.71,-74.07],[6.25,-75.56],
      [51.51,-0.13],[48.86,2.35],[52.52,13.40],[50.11,8.68],
      [40.42,-3.70],[41.39,2.17],[45.46,9.19],[48.21,16.37],
      [52.23,21.01],[59.33,18.06],[52.37,4.90],[50.85,4.35],
      [30.05,31.24],[33.59,-7.62],[-1.29,36.82],[6.52,3.38],
      [-26.20,28.05],[-33.93,18.42],[28.61,77.21],[19.08,72.88],
      [12.97,77.59],[13.76,100.50],[21.03,105.85],[1.35,103.82],
      [35.68,139.69],[34.69,135.50],[37.57,126.98],[31.23,121.47],
      [39.90,116.41],[25.20,55.27],[24.71,46.67],[41.01,28.98],
      [-33.87,151.21],[-37.81,144.96],[-27.47,153.03],[-36.85,174.76]
    ];
    function globe(){return root.__smLiveGlobeState&&root.__smLiveGlobeState.globe}
    function disabled(){return stopped||!document.body.contains(root)||root.classList.contains('sm-bb-active')}
    function apply(){
      var g=globe();if(!g||typeof g.pointsData!=='function')return;
      if(root.classList.contains('sm-bb-active'))return;
      try{
        var other=(g.pointsData()||[]).filter(function(p){return p&&p.__smKind!=='ambient-network-signal'});
        var visible=disabled()?[]:current.filter(function(p){return p.expires>Date.now()});
        root.__smAmbientPoints=visible;
        pointAccessors(g);
        g.pointsData(other.concat(visible));
      }catch(e){}
    }
    function clearExpired(){current=current.filter(function(p){return p.expires>Date.now()});root.__smAmbientPoints=current;apply()}
    function cycle(){
      if(stopped)return;
      if(!disabled()&&!document.hidden&&globe()){
        var options=land.slice(),n=2+Math.floor(Math.random()*3),now=Date.now();
        while(n--&&options.length){
          var i=Math.floor(Math.random()*options.length),coord=options.splice(i,1)[0],duration=20000+Math.round(Math.random()*10000);
          current.push({lat:coord[0],lng:coord[1],altitude:.105,radius:.20,color:'#00E5FF',label:'Ambient network animation · simulated',__smKind:'ambient-network-signal',expires:now+duration,id:'ambient-'+(++counter)});
          expiryTimers.push(setTimeout(clearExpired,duration+50));
        }
        apply();
      }
      cycleTimer=setTimeout(cycle,60000+Math.round(Math.random()*60000));
    }
    var observer=new MutationObserver(function(){
      if(root.classList.contains('sm-bb-active')){current=[];root.__smAmbientPoints=[];}
      else apply();
    });
    observer.observe(root,{attributes:true,attributeFilter:['class']});
    cycleTimer=setTimeout(cycle,60000+Math.round(Math.random()*60000));
    root.__smAmbientCleanup=function(){
      stopped=true;clearTimeout(cycleTimer);expiryTimers.forEach(clearTimeout);observer.disconnect();
      current=[];root.__smAmbientPoints=[];apply();root.__smAmbientCleanup=null;
    };
  }

  function installBrooklynSkyline(g,opt){
    if(typeof g.htmlElementsData!=='function')return;
    try{
      var data=g.htmlElementsData()||[];
      data=data.filter(function(x){return !(x&&x.__smKind==='brooklyn-skyline')});
      if(opt.showBrooklynHub===false||document.querySelector('[data-sm-world-live].sm-bb-active')){g.htmlElementsData(data);return}
      data.push({lat:HOME.lat,lng:HOME.lng,altitude:.022,__smKind:'brooklyn-skyline'});
      g.htmlLat('lat').htmlLng('lng').htmlAltitude('altitude').htmlElement(function(d){
        
        var wrap=document.createElement('div');
        wrap.setAttribute('aria-label','Brooklyn hub, New York City');
        wrap.style.cssText='pointer-events:none;transform:translate(-50%,-50%);width:30px;height:30px;display:grid;place-items:center;background:transparent;border:0;box-shadow:none;';
        var img=document.createElement('img');
        var icon=document.querySelector('link[rel~="icon"],link[rel="shortcut icon"]');
        img.src=icon&&icon.href?icon.href:'/favicon.ico';
        img.alt='';img.width=30;img.height=30;
        img.style.cssText='display:block;width:30px;height:30px;object-fit:cover;background:transparent;border:0;border-radius:50%;clip-path:circle(50% at 50% 50%);filter:drop-shadow(0 0 5px rgba(255,48,54,.9));';
        wrap.appendChild(img);
        return wrap;
      }).htmlElementsData(data);
    }catch(e){}
  }

  function installBrooklyn(g,opt){
    if(opt.showBrooklynHub===false){
      removePointKind(g,'home');
      removePointKind(g,'home-beam');
      removeRingKind(g,'home');
      removeRingKind(g,'home-radio-2');
      removeRingKind(g,'home-radio-3');
      installBrooklynSkyline(g,opt);
      return;
    }
    var red=opt.brooklynHubColor||'#ff3b30';
    removePointKind(g,'home-beam');
    mergePoint(g,{lat:HOME.lat,lng:HOME.lng,color:red,radius:.10,altitude:.012,__smKind:'home'});

    var rings=removeRingKind(g,'home');
    rings=removeRingKind(g,'home-radio-2');
    rings=removeRingKind(g,'home-radio-3');
    rings.push({lat:HOME.lat,lng:HOME.lng,color:red,altitude:.018,maxRadius:1.15,speed:.28,repeat:2200,__smKind:'home'});
    rings.push({lat:HOME.lat,lng:HOME.lng,color:'rgba(255,48,54,.8)',altitude:.019,maxRadius:1.55,speed:.24,repeat:3100,__smKind:'home-radio-2'});
    rings.push({lat:HOME.lat,lng:HOME.lng,color:'rgba(255,48,54,.55)',altitude:.020,maxRadius:2.05,speed:.20,repeat:4200,__smKind:'home-radio-3'});
    try{
      g.ringLat('lat').ringLng('lng')
       .ringAltitude(function(r){return typeof r.altitude==='number'?r.altitude:.02})
       .ringColor(function(r){return r.color||red})
       .ringMaxRadius(function(r){return r.maxRadius||1.2})
       .ringPropagationSpeed(function(r){return r.speed||.3})
       .ringRepeatPeriod(function(r){return typeof r.repeat==='number'?r.repeat:2600})
       .ringsData(rings);
    }catch(e){}

    try{g.arcsData((g.arcsData()||[]).filter(function(a){return !(a&&a.__smKind==='home-static-beam')}));}catch(e){}

    installBrooklynSkyline(g,opt);
  }

  function setVisitor(root,g,lat,lng,state,opt){
    if(opt.showVisitorPoint===false){removePointKind(g,'visitor');removeRingKind(g,'visitor');return}
    var active=state==='active',color=active?opt.aqua:opt.purple;
    mergePoint(g,{lat:lat,lng:lng,color:color,radius:typeof opt.visitorPointSize==='number'?opt.visitorPointSize:(active?.17:.13),altitude:.018,__smKind:'visitor'});
    if(active&&opt.showVisitorPulse!==false)mergeRing(g,{lat:lat,lng:lng,color:color,maxRadius:typeof opt.visitorPulseRadius==='number'?opt.visitorPulseRadius:1.25,speed:typeof opt.visitorPulseSpeed==='number'?opt.visitorPulseSpeed:.28,repeat:3100,__smKind:'visitor'});
    else removeRingKind(g,'visitor');
    root.dataset.smVisitorState=state;
  }

  function clusterVisitors(active,recent,ownShortId){
    var activeIds={};(active||[]).forEach(function(v){if(v&&v.id)activeIds[v.id]=true});
    var rows=[];
    (active||[]).forEach(function(v){if(!(ownShortId&&v&&v.id===ownShortId))rows.push({v:v,state:'active'})});
    (recent||[]).forEach(function(v){if(!(v&&v.id&&activeIds[v.id]))rows.push({v:v,state:'recent'})});
    var groups={};
    rows.forEach(function(row){
      var loc=row.v&&row.v.location||{},lat=Number(loc.lat),lng=Number(loc.lng);
      if(!isFinite(lat)||!isFinite(lng))return;
      var key=(Math.round(lat/1.8)*1.8).toFixed(1)+'|'+(Math.round(lng/1.8)*1.8).toFixed(1);
      if(!groups[key])groups[key]={lat:0,lng:0,n:0,active:0,recent:0,viewers:[]};
      var g=groups[key];g.lat+=lat;g.lng+=lng;g.n++;if(row.state==='active')g.active++;else g.recent++;
      g.viewers.push({id:row.v.id||'',state:row.state,location:loc,current_view:row.v.current_view||''});
    });
    return Object.keys(groups).map(function(k){var g=groups[k];g.lat/=g.n;g.lng/=g.n;return g});
  }
  function setActivityPoints(g,active,recent,opt,ownShortId){
    var pts=[];try{pts=g.pointsData()||[]}catch(e){}
    pts=pts.filter(function(p){return !(p&&p.__smKind==='activity')});
    var lifetimePts=pts.filter(function(p){return p&&p.__smKind==='lifetime-location'});
    var clusters=clusterVisitors(active,recent,ownShortId),labels=[];
    clusters.forEach(function(c){
      var state=c.active>0?'active':'recent',meta=eventMeta(null,state);
      var rows=c.viewers.map(function(v){
        var place=locationLabel(v.location),view=String(v.current_view||'').trim();
        return '<div style="margin-top:5px;padding-top:5px;border-top:1px solid rgba(32,244,247,.18)"><strong>'+esc(place)+'</strong>'+(view?'<br><span style="color:#dff">'+esc(view)+'</span>':'')+'</div>';
      }).join('');
      var label='<div style="min-width:190px;max-width:260px;padding:7px 8px;font:700 11px/1.35 Arial,sans-serif;color:#fff;background:rgba(2,10,12,.94);border:2px solid rgba(32,244,247,.65);border-radius:8px;box-shadow:0 0 18px rgba(32,244,247,.16)">'+
        '<div style="font-size:12px;color:'+meta.color+'">'+(c.n>1?c.n+' VIEWERS':'1 VIEWER')+'</div>'+rows+'</div>';
      var base=state==='active'?(typeof opt.visitorPointSize==='number'?opt.visitorPointSize:.17):Math.max(.08,(typeof opt.visitorPointSize==='number'?opt.visitorPointSize:.13)*.8);
      var radius=Math.min(.34,base+(c.n-1)*.035);
      pts.push({lat:c.lat,lng:c.lng,color:meta.color,radius:radius,altitude:.02,label:opt.showPointLabels===false?'':label,__smKind:'activity',__smState:state,__smCount:c.n});
      if(c.n>1)labels.push({lat:c.lat,lng:c.lng,text:String(c.n),color:'#ffffff'});
    });
    lifetimePts.forEach(function(p){if(!pts.some(function(x){return x===p}))pts.push(p)});
    pointAccessors(g);try{g.pointsData(pts)}catch(e){}
    try{
      if(typeof g.labelsData==='function'){
        g.labelsData(labels)
         .labelLat('lat').labelLng('lng').labelText('text')
         .labelColor(function(d){return d.color||'#fff'})
         .labelSize(.45).labelDotRadius(0).labelAltitude(.035).labelResolution(2);
      }
    }catch(e){}
  }

  function smPointInRing(lng,lat,ring){
    var inside=false;
    if(!ring||ring.length<3)return false;
    for(var i=0,j=ring.length-1;i<ring.length;j=i++){
      var xi=Number(ring[i][0]),yi=Number(ring[i][1]),xj=Number(ring[j][0]),yj=Number(ring[j][1]);
      var hit=((yi>lat)!==(yj>lat))&&(lng<(xj-xi)*(lat-yi)/((yj-yi)||1e-12)+xi);
      if(hit)inside=!inside;
    }
    return inside;
  }
  function smFeatureBox(f){
    if(f.__smBBox)return f.__smBBox;
    var minX=180,minY=90,maxX=-180,maxY=-90,g=f&&f.geometry,c=g&&g.coordinates;
    function walk(a){
      if(!Array.isArray(a))return;
      if(typeof a[0]==='number'&&typeof a[1]==='number'){
        var x=Number(a[0]),y=Number(a[1]);if(isFinite(x)&&isFinite(y)){minX=Math.min(minX,x);maxX=Math.max(maxX,x);minY=Math.min(minY,y);maxY=Math.max(maxY,y)}
      }else a.forEach(walk);
    }
    walk(c);f.__smBBox=[minX,minY,maxX,maxY];return f.__smBBox;
  }
  function smPolygonContains(poly,lng,lat){
    if(!poly||!poly.length||!smPointInRing(lng,lat,poly[0]))return false;
    for(var i=1;i<poly.length;i++)if(smPointInRing(lng,lat,poly[i]))return false;
    return true;
  }
  function smFeatureContains(f,lng,lat){
    var g=f&&f.geometry;if(!g)return false;
    var b=smFeatureBox(f);if(lng<b[0]||lng>b[2]||lat<b[1]||lat>b[3])return false;
    if(g.type==='Polygon')return smPolygonContains(g.coordinates,lng,lat);
    if(g.type==='MultiPolygon'){for(var i=0;i<g.coordinates.length;i++)if(smPolygonContains(g.coordinates[i],lng,lat))return true}
    return false;
  }
  function regionName(f){
    var p=f&&f.properties||{};
    return p.name||p.NAME_1||p.NAME||p.admin||p.region||p.sovereignt||'Region';
  }
  function heatLabel(f){
    var score=Number(f&&f.__smHeatScore)||0,count=Number(f&&f.__smHeatCount)||0;
    if(score<=0)return '<div style="padding:7px 9px;font:700 11px Arial;color:#fff;background:rgba(12,3,4,.94);border:1px solid rgba(255,213,74,.28);border-radius:7px"><strong>'+esc(regionName(f))+'</strong><br><span style="color:#aaa">No recorded audience activity yet</span></div>';
    var color=heatColor(score,settings(document.querySelector('[data-sm-world-live]')||document));
    var level=score>=60?'Heavy':score>=25?'Strong':score>=8?'Growing':'Few visits';
    return '<div style="padding:7px 9px;font:700 11px/1.35 Arial;color:#fff;background:rgba(12,3,4,.94);border:1px solid '+color+';border-radius:7px;box-shadow:0 0 14px '+color+'33"><strong>'+esc(regionName(f))+'</strong><br><span style="color:'+color+'">AUDIENCE ACTIVITY: '+level.toUpperCase()+'</span><br><span style="color:#ddd">'+count+' recorded visits</span></div>';
  }

  function heatColor(score,opt){
    if(score>=60)return opt.heatHot||'#FF2A2A';
    if(score>=25)return opt.heatHigh||'#FF6A00';
    if(score>=8)return opt.heatMid||'#FFB000';
    return opt.heatLow||'#FFD54A';
  }
  function setLifetimeLocationPoints(g,heatCells,opt,routes){
    if(document.querySelector('[data-sm-world-live].sm-bb-active'))return;
    /* Hard lock: the map point layer contains lifetime locations only. */
    var pts=[];
    (Array.isArray(heatCells)?heatCells:[]).forEach(function(h){
      var lat=Number(h.lat),lng=Number(h.lng),count=Number(h.lifetime)||0;
      if(!isFinite(lat)||!isFinite(lng)||count<=0)return;
      var named=(Array.isArray(routes)?routes:[]).find(function(v){return Math.abs(Number(v.lat)-lat)<.01&&Math.abs(Number(v.lng)-lng)<.01});
      var city=named&&named.city||'',country=named&&named.country||'';
      pts.push({lat:lat,lng:lng,city:city,country:country,lifetime:count,visits_24h:Number(h.visits_24h)||0,color:'#FFE477',radius:Math.min(.23,.10+Math.log(count+1)*.028),altitude:.095,__smKind:'lifetime-location',label:(city?[city,country].filter(Boolean).join(', '):'All-time location')+' · '+count+' recorded visit'+(count===1?'':'s')});
    });
    var halos=pts.map(function(p){return Object.assign({},p,{color:'rgba(255,213,74,.12)',radius:p.radius*1.55,altitude:.082})});
    pointAccessors(g);try{var ambient=(g.pointsData()||[]).filter(function(p){return p&&p.__smKind==='ambient-network-signal'&&p.expires>Date.now()});g.pointsData(halos.concat(pts,ambient))}catch(e){}
  }
  function setLiveVisitorPulses(g,active,root){
    if(document.querySelector('[data-sm-world-live].sm-bb-active'))return;
    if(!g||typeof g.ringsData!=='function')return;
    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var groups={};
    (Array.isArray(active)?active:[]).forEach(function(v){
      var loc=v&&v.location;
      if(!loc||loc.lat==null||loc.lng==null||loc.lat===''||loc.lng==='')return;
      var lat=Number(loc.lat),lng=Number(loc.lng);
      if(!isFinite(lat)||!isFinite(lng)||Math.abs(lat)>90||Math.abs(lng)>180)return;
      var key=lat.toFixed(2)+'|'+lng.toFixed(2);
      if(!groups[key])groups[key]={lat:lat,lng:lng,color:'rgba(0,229,255,.65)',altitude:.032,maxRadius:1.15,speed:.28,repeat:2200,__smKind:'live-visitor'};
    });
    var rings=(g.ringsData()||[]).filter(function(r){return !(r&&r.__smKind==='live-visitor')});
    var livePoints=(g.pointsData()||[]).filter(function(p){return !(p&&p.__smKind==='live-visitor')});
    Object.keys(groups).forEach(function(k){var p=groups[k];livePoints.push({lat:p.lat,lng:p.lng,color:'rgba(0,229,255,.20)',radius:.20,altitude:.093,__smKind:'live-visitor',label:'Live visitor'});livePoints.push({lat:p.lat,lng:p.lng,color:'#00E5FF',radius:.14,altitude:.105,__smKind:'live-visitor',label:'Live visitor'})});
    if(root&&Array.isArray(root.__smAmbientPoints))livePoints=livePoints.concat(root.__smAmbientPoints.filter(function(p){return p&&p.expires>Date.now()}));
    pointAccessors(g);g.pointsData(livePoints);
    if(!reduced)Object.keys(groups).forEach(function(k){var p=groups[k];rings.push(p,Object.assign({},p,{altitude:.033,maxRadius:1.55,speed:.24,repeat:3100}),Object.assign({},p,{altitude:.034,maxRadius:2.05,speed:.20,repeat:4200}))});
    g.ringLat('lat').ringLng('lng')
      .ringAltitude(function(r){return typeof r.altitude==='number'?r.altitude:.02})
      .ringColor(function(r){return r.__smKind==='live-visitor'?function(t){return 'rgba(0,229,255,'+(.65*Math.pow(1-Math.min(1,Math.max(0,t)),2))+')'}:r.color||'#ff3036'})
      .ringMaxRadius(function(r){return r.maxRadius||1.2})
      .ringPropagationSpeed(function(r){return r.speed||.3})
      .ringRepeatPeriod(function(r){return typeof r.repeat==='number'?r.repeat:2600})
      .ringsData(rings);
  }
  function updateHeat(root,g,opt,active,recent,heatCells){
    var layers=root.__smBoundaryFeatures;if(!layers)return;
    var countries=layers.countries||[],admin=layers.admin||[],all=countries.concat(admin);
    all.forEach(function(f){f.__smHeatScore=0;f.__smHeatCount=0});
    if(opt.showHeatLayer!==false){
      if(Array.isArray(heatCells)&&heatCells.length){
        heatCells.forEach(function(h){
          var lat=Number(h.lat),lng=Number(h.lng);if(!isFinite(lat)||!isFinite(lng))return;
          var score=Number(h.lifetime)||0;
          var hit=null;
          for(var i=0;i<admin.length;i++){if(smFeatureContains(admin[i],lng,lat)){hit=admin[i];break}}
          if(!hit){for(var j=0;j<countries.length;j++){if(smFeatureContains(countries[j],lng,lat)){hit=countries[j];break}}}
          if(hit){hit.__smHeatScore=(hit.__smHeatScore||0)+score;hit.__smHeatCount=(hit.__smHeatCount||0)+(Number(h.lifetime)||0)}
        });
      }else{
        var seen={},traffic=[];
        (active||[]).concat(recent||[]).forEach(function(v){var key=v&&v.id?v.id:JSON.stringify(v&&v.location||{});if(seen[key])return;seen[key]=1;traffic.push(v)});
        traffic.forEach(function(v){
          var loc=v&&v.location||{},lat=Number(loc.lat),lng=Number(loc.lng);if(!isFinite(lat)||!isFinite(lng))return;
          var hit=null;for(var i=0;i<admin.length;i++){if(smFeatureContains(admin[i],lng,lat)){hit=admin[i];break}}
          if(!hit){for(var j=0;j<countries.length;j++){if(smFeatureContains(countries[j],lng,lat)){hit=countries[j];break}}}
          if(hit){hit.__smHeatScore=(hit.__smHeatScore||0)+1;hit.__smHeatCount=(hit.__smHeatCount||0)+1}
        });
      }
    }
    var hot=0,visits=0;all.forEach(function(f){var s=Number(f.__smHeatScore)||0;if(s>0){hot++;visits+=Number(f.__smHeatCount)||0}});
    root.dataset.smHeatRegions=String(hot);root.dataset.smHeatVisits=String(visits);
    try{g.polygonsData(all)}catch(e){}
  }

  function bindSharedGeo(root,g,opt){
    if(root.__smSharedGeoCleanup)root.__smSharedGeoCleanup();
    root.dataset.smGeoMode='coarse-backend-only';
    function onGeo(e){
      var d=e&&e.detail||{},lat=Number(d.lat),lng=Number(d.lng);
      if(!isFinite(lat)||!isFinite(lng))return;
      root.__smVisitorCoords={lat:lat,lng:lng};
      removePointKind(g,'visitor');removeRingKind(g,'visitor');
    }
    document.addEventListener('sm:coarse-visitor-geo',onGeo);
    root.__smSharedGeoCleanup=function(){document.removeEventListener('sm:coarse-visitor-geo',onGeo);root.__smSharedGeoCleanup=null};
  }

  function setStatHeat(){}
  function fillRatio(value,max){
    value=Number(value)||0;max=Math.max(1,Number(max)||1);
    if(value<=0)return 0;
    return Math.max(10,Math.min(100,(value/max)*100));
  }
  function updateAudienceMeter(root,liveCount,locCount,recentCount,topScore){
    var fill=root.querySelector('[data-sm-audience-meter]');
    var label=root.querySelector('[data-sm-audience-meter-label]');
    if(!fill||!label)return;
    var live=Math.max(0,Number(liveCount)||0),locations=Math.max(0,Number(locCount)||0);var strength=Math.min(100,live*12+locations*6);
    fill.style.width=strength+'%';
    var text=strength>=75?'HEAVY':strength>=50?'STRONG':strength>=24?'GROWING':strength>0?'LIGHT':'QUIET';
    label.textContent=text;
    label.style.color=strength>=75?'#FF2A2A':strength>=50?'#FF6A00':strength>=24?'#FFB000':'#FFD54A';
  }
  function levelFor(value,cuts){
    value=Number(value)||0;
    if(value<=0)return 0;
    if(value>=cuts[2])return 4;
    if(value>=cuts[1])return 3;
    if(value>=cuts[0])return 2;
    return 1;
  }

  function categoryTag(view){
    view=String(view||'').toUpperCase();
    if(/TUNNEL/.test(view))return'TUNNEL';
    if(/STICKER|SLAP|CUSTOM/.test(view))return'STICKERS';
    if(/VINYL/.test(view))return'VINYL';
    if(/APPAREL|SHIRT|HOODIE/.test(view))return'APPAREL';
    if(/PRINT/.test(view))return'PRINTS';
    if(/PIN/.test(view))return'PINS';
    if(/ART|GRAFFITI|ORIGINAL/.test(view))return'ART';
    if(/CART/.test(view))return'CART';
    if(/SHOP|COLLECTION/.test(view))return'SHOP';
    if(/HOME/.test(view))return'HOME';
    return'BROWSE';
  }
  function relativeSeen(v,state){
    if(state==='active')return'LIVE';
    var raw=v&&(v.last_seen||v.lastSeen||v.updated_at||v.updatedAt||v.seen_at||v.seenAt||v.timestamp||v.created_at||v.createdAt);
    if(!raw)return'RECENT';
    var t=Date.parse(raw);if(!isFinite(t))return'RECENT';
    var s=Math.max(0,Math.round((Date.now()-t)/1000));
    if(s<60)return s+'s ago';
    if(s<3600)return Math.floor(s/60)+'m ago';
    if(s<86400)return Math.floor(s/3600)+'h ago';
    return Math.floor(s/86400)+'d ago';
  }
  function shortRegion(loc){
    loc=loc||{};
    var r=String(loc.region||'').trim();
    if(r){
      var m=r.match(/\b([A-Z]{2})\b/);
      if(m)return m[1];
      return r.length<=8?r.toUpperCase():r.slice(0,8).toUpperCase();
    }
    return String(loc.country||'').toUpperCase()||'GLOBAL';
  }
  function setRegionalBadges(g,active,recent,opt){
    var rows=(active||[]).concat(recent||[]),groups={};
    rows.forEach(function(v){
      var loc=v&&v.location||{},lat=Number(loc.lat),lng=Number(loc.lng);
      if(!isFinite(lat)||!isFinite(lng))return;
      var key=shortRegion(loc),x=groups[key]||(groups[key]={lat:0,lng:0,n:0});
      x.lat+=lat;x.lng+=lng;x.n++;
    });
    var labels=[];
    Object.keys(groups).forEach(function(k){
      var x=groups[k];if(x.n<2)return;
      labels.push({lat:x.lat/x.n,lng:x.lng/x.n,text:k+' '+x.n,color:'#ffffff'});
    });
    try{
      if(typeof g.labelsData==='function'){
        g.labelsData(labels)
          .labelLat('lat').labelLng('lng').labelText('text')
          .labelColor(function(d){return d.color||'#fff'})
          .labelSize(.38).labelDotRadius(.12).labelAltitude(.04).labelResolution(2);
      }
    }catch(e){}
  }
  function visits24h(heat){
    return (Array.isArray(heat)?heat:[]).reduce(function(sum,h){return sum+(Number(h&&h.visits_24h)||0)},0);
  }
  function renderPurchaseSignals(root,purchases){
    if(!Array.isArray(purchases)||!purchases.length)return;
    root.__smPurchaseRows=root.__smPurchaseRows||{};
    purchases.slice(0,5).forEach(function(p){
      if(!p||!p.id)return;
      root.__smPurchaseRows[p.id]={id:p.id,location:p.location||{},current_view:'ORDER RECEIVED',purchase:true,last_seen:p.created_at||p.createdAt||p.timestamp||new Date().toISOString()};
    });
  }

  function renderSharedFeed(root,active,recent,ownShortId){
    var list=root.querySelector('[data-sm-feed]');if(!list)return;
    active=Array.isArray(active)?active:[];
    recent=Array.isArray(recent)?recent:[];
    recent=recent.filter(function(v){
      var raw=v&&(v.last_seen||v.lastSeen||v.updated_at||v.updatedAt||v.seen_at||v.seenAt||v.timestamp||v.departed_at||v.created_at||v.createdAt);
      var t=Date.parse(raw||'');
      return isFinite(t)&&Date.now()-t<2592000000;
    });
    function viewKey(v){return String(v&&v.current_view||'').replace(/\s+/g,' ').trim().toLowerCase()}
    function isItemView(v){return /product|collection|sticker|slap|vinyl|apparel|shirt|hoodie|print|pin|art|graffiti|cart/i.test(String(v||''))}
    var liveViewCounts={},recent10Counts={},now=Date.now();
    active.forEach(function(v){var k=viewKey(v);if(k&&isItemView(k))liveViewCounts[k]=(liveViewCounts[k]||0)+1});
    recent.forEach(function(v){
      var k=viewKey(v),raw=v&&(v.last_seen||v.lastSeen||v.updated_at||v.updatedAt||v.seen_at||v.seenAt||v.timestamp||v.created_at||v.createdAt),t=Date.parse(raw||'');
      if(k&&isItemView(k)&&isFinite(t)&&now-t<=600000)recent10Counts[k]=(recent10Counts[k]||0)+1;
    });
    var activeIds={},rows=[];
    active.forEach(function(v){if(v&&v.id)activeIds[v.id]=1;rows.push({v:v,state:'active'})});
    recent.forEach(function(v){if(v&&v.id&&activeIds[v.id])return;rows.push({v:v,state:'recent'})});
    var purchases=root.__smPurchaseRows||{};
    Object.keys(purchases).forEach(function(id){rows.push({v:purchases[id],state:'recent',purchase:true})});
    var latestById={};
    rows.forEach(function(row){
      var v=row.v||{},loc=v.location||{},key=v.id||[loc.city||'',loc.region||'',loc.country||'',v.current_view||'',row.purchase?'purchase':row.state].join('|');
      if(!latestById[key]||row.state==='active'||row.purchase)latestById[key]=row;
    });
    rows=Object.keys(latestById).map(function(k){return latestById[k]}).slice(0,10);
    list.innerHTML='';
    rows.forEach(function(row,index){
      var v=row.v||{},loc=v.location||{};
      var place=locationLabel(loc),view=String(v.current_view||'').trim()||'Browsing StyleMechanics',vk=viewKey(v);
      var isYou=!!(ownShortId&&v.id&&String(v.id)===String(ownShortId));
      var el=document.createElement('div');
      el.className='sm-world-live__feed-row'+(isYou?' is-you':'')+(row.purchase?' is-purchase':'');
      var num=document.createElement('b');num.className='sm-world-live__feed-num';num.textContent=String(index+1).padStart(2,'0');
      var signal=document.createElement('span');signal.className='sm-world-live__feed-signal';
      var dot=document.createElement('i');dot.className=row.purchase?'purchase-dot':(row.state==='active'?'aqua':'purple');
      var placeEl=document.createElement('strong');placeEl.textContent=isYou?'YOU • '+place:place;
      var meta=document.createElement('small');meta.className='sm-world-live__feed-meta';
      var tag=document.createElement('em');tag.textContent=row.purchase?'ORDER':categoryTag(view);
      var viewEl=document.createElement('span'),proof='';
      if(!row.purchase&&row.state==='active'&&(liveViewCounts[vk]||0)>=2)proof=' • '+liveViewCounts[vk]+' VIEWING NOW';
      else if(!row.purchase&&(recent10Counts[vk]||0)>=3)proof=' • '+recent10Counts[vk]+' VIEWS / 10 MIN';
      viewEl.textContent=view+proof;
      meta.appendChild(tag);meta.appendChild(viewEl);
      signal.appendChild(dot);signal.appendChild(placeEl);signal.appendChild(meta);
      var state=document.createElement('time');
      state.textContent=isYou?'YOU':(row.purchase?'ORDER':relativeSeen(v,row.state));
      state.className=row.purchase?'is-order':(row.state==='active'?'is-live':'is-recent');
      el.appendChild(num);el.appendChild(signal);el.appendChild(state);list.appendChild(el);
    });
    for(var i=rows.length;i<10;i++){
      var empty=document.createElement('div');empty.className='sm-world-live__feed-row sm-world-live__feed-row--empty';
      empty.innerHTML='<b class="sm-world-live__feed-num">'+String(i+1).padStart(2,'0')+'</b><span class="sm-world-live__feed-signal"><i class="purple"></i><strong>WAITING FOR SIGNAL</strong><small>Real visitor activity appears here</small></span><time>—</time>';
      list.appendChild(empty);
    }
  }

  function updateLiveStats(root,active,recent){
    active=Array.isArray(active)?active:[];
    recent=Array.isArray(recent)?recent:[];
    var activeIds={};
    active.forEach(function(v){if(v&&v.id)activeIds[v.id]=1});
    var recentOnly=recent.filter(function(v){
      if(v&&v.id&&activeIds[v.id])return false;
      var raw=v&&(v.last_seen||v.lastSeen||v.updated_at||v.updatedAt||v.seen_at||v.seenAt||v.timestamp||v.departed_at||v.created_at||v.createdAt);
      var t=Date.parse(raw||'');
      return isFinite(t)&&Date.now()-t<2592000000;
    });
    var locations={};
    active.forEach(function(v){
      var loc=v&&v.location||{};
      var key=[loc.city||'',loc.region||'',loc.country||''].join('|').toLowerCase();
      if(!key.replace(/\|/g,'')){
        var lat=Number(loc.lat),lng=Number(loc.lng);
        if(loc.lat!=null&&loc.lng!=null&&loc.lat!==''&&loc.lng!==''&&isFinite(lat)&&isFinite(lng))key=(Math.round(lat*2)/2)+'|'+(Math.round(lng*2)/2);
      }
      if(key)locations[key]=1;
    });
    var scores={};
    function addViews(list,weight){
      (list||[]).forEach(function(v){
        var label=String(v&&v.current_view||'').replace(/^Viewing\s+/i,'').replace(/^collection\s*[•-]\s*/i,'').replace(/^product\s*[•-]\s*/i,'').trim();
        if(!label)return;
        var key=label.toUpperCase();
        if(!scores[key])scores[key]={label:label,score:0};
        scores[key].score+=weight;
      });
    }
    addViews(active,3);
    addViews(recentOnly,1);
    var top='—',best=-1;
    Object.keys(scores).forEach(function(k){
      if(scores[k].score>best){best=scores[k].score;top=scores[k].label}
    });
    var liveEl=root.querySelector('[data-sm-live-now]');
    var locEl=root.querySelector('[data-sm-active-locations]');
    var recentEl=root.querySelector('[data-sm-recent-visitors]');
    var topEl=root.querySelector('[data-sm-top-view]');
    var visits24El=root.querySelector('[data-sm-visits-24h]');
    var liveCount=active.length,locCount=Object.keys(locations).length;
    var recentCutoff=Date.now()-86400000,recentSeen={},recentCount=0;
    recent.concat(active).forEach(function(v){
      var raw=v&&(v.last_seen||v.lastSeen||v.updated_at||v.updatedAt||v.seen_at||v.seenAt||v.timestamp||v.departed_at||v.created_at||v.createdAt);
      var t=Date.parse(raw||'');if(!isFinite(t)&&active.indexOf(v)!==-1)t=Date.now();if(!isFinite(t)||t<recentCutoff)return;
      var key=String(v&&v.id||'')||[v&&v.location&&v.location.city||'',v&&v.location&&v.location.region||'',v&&v.location&&v.location.country||'',raw].join('|');
      if(recentSeen[key])return;recentSeen[key]=1;recentCount++;
    });
    if(liveEl)liveEl.textContent=String(liveCount);
    if(locEl)locEl.textContent=String(locCount);
    if(recentEl){recentEl.textContent=String(recentCount);recentEl.title='Unique recent sessions in the last 24 hours';var recentLabel=recentEl.parentElement&&recentEl.parentElement.querySelector('span');if(recentLabel)recentLabel.textContent='RECENT 24H';}
    if(topEl){topEl.textContent=top;topEl.title=top}
    if(visits24El)visits24El.textContent=String(Number(root.__smVisits24h)||0);

    updateAudienceMeter(root,liveCount,locCount,recentCount,best);
  }

  function startActivity(root,g,opt){
    if(root.__smActivityCleanup)root.__smActivityCleanup();
    var sessionId=null,heartbeatTimer=null,pollTimer=null,stopped=false,inFlight=false;
    root.dataset.smActivityBackend='railway';
    function api(path,options){options=options||{};options.mode='cors';options.credentials='omit';options.headers=Object.assign({},options.headers||{});if(ownerMode())options.headers['X-SM-Owner']='1';return fetch(API+path,options)}
    function post(path,body,keepalive){return api(path,{method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify(body||{}),keepalive:!!keepalive}).then(function(r){if(!r.ok)throw new Error(path+' '+r.status);if(r.status===204)return {ignored:true};return r.json()})}
    function emitOwn(loc,state){var lat=Number(loc&&loc.lat),lng=Number(loc&&loc.lng);if(!isFinite(lat)||!isFinite(lng))return;document.dispatchEvent(new CustomEvent('sm:coarse-visitor-geo',{detail:{lat:lat,lng:lng,state:state||'active'}}))}
    function firePurchaseBeams(list){
      if(!Array.isArray(list)||!list.length)return;
      root.__smSeenPurchases=root.__smSeenPurchases||{};
      list.forEach(function(p){
        if(!p||!p.id||root.__smSeenPurchases[p.id])return;
        var loc=p.location||{},lat=Number(loc.lat),lng=Number(loc.lng);if(!isFinite(lat)||!isFinite(lng))return;
        root.__smSeenPurchases[p.id]=1;
        try{
          var arcs=g.arcsData()||[];
          arcs=arcs.filter(function(a){return !(a&&a.__smKind==='purchase-beam'&&a.__smId===p.id)});
          arcs.push({startLat:lat,startLng:lng,endLat:HOME.lat,endLng:HOME.lng,color:'#32E875',__smKind:'purchase-beam',__smId:p.id});
          g.arcStartLat('startLat').arcStartLng('startLng').arcEndLat('endLat').arcEndLng('endLng')
           .arcColor(function(a){return a.color||'#32E875'}).arcAltitude(.22).arcStroke(.42)
           .arcDashLength(.32).arcDashGap(.12).arcDashAnimateTime(850).arcsData(arcs);
          var rings=g.ringsData()||[];
          rings.push({lat:lat,lng:lng,color:'#32E875',altitude:.045,maxRadius:.75,speed:.5,repeat:1200,__smKind:'purchase-flash',__smId:p.id});
          rings.push({lat:HOME.lat,lng:HOME.lng,color:'#ff3b30',altitude:.07,maxRadius:1.5,speed:.55,repeat:850,__smKind:'purchase-flash',__smId:p.id+'-home'});
          g.ringLat('lat').ringLng('lng').ringAltitude(function(r){return typeof r.altitude==='number'?r.altitude:.02})
           .ringColor(function(r){return r.color||'#20F4F7'}).ringMaxRadius(function(r){return r.maxRadius||1})
           .ringPropagationSpeed(function(r){return r.speed||.35}).ringRepeatPeriod(function(r){return typeof r.repeat==='number'?r.repeat:1600}).ringsData(rings);
          setTimeout(function(){
            try{g.arcsData((g.arcsData()||[]).filter(function(a){return !(a&&a.__smKind==='purchase-beam'&&a.__smId===p.id)}));
                g.ringsData((g.ringsData()||[]).filter(function(r){return !(r&&r.__smKind==='purchase-flash'&&(r.__smId===p.id||r.__smId===p.id+'-home'))}))}catch(e){}
          },6500);
        }catch(e){}
      });
    }
    function poll(){if(stopped||inFlight)return;inFlight=true;api('/activity',{method:'GET',cache:'no-store'}).then(function(r){if(!r.ok)throw new Error('activity '+r.status);if(r.status===204)throw new Error('activity unavailable (204)');return r.json()}).then(function(d){
      if(stopped)return;
      if(!d||!Array.isArray(d.active)||!Array.isArray(d.recent))throw new Error('Invalid activity response');
      /* A normal storefront visitor sees their own live session. Owner previews are already filtered by the API. */
      var publicActive=(d&&d.active||[]);
      var recentCutoff24=Date.now()-86400000;
      var publicRecent=(d&&d.recent||[]).filter(function(v){
        var raw=v&&(v.last_seen||v.lastSeen||v.updated_at||v.updatedAt||v.seen_at||v.seenAt||v.timestamp||v.departed_at||v.created_at||v.createdAt);
        var t=Date.parse(raw||'');
        return isFinite(t)&&t>=recentCutoff24;
      });
      /* The globe is lifetime-only. Live/recent activity updates the dashboard/feed,
         but must never replace, relabel, or otherwise redraw the geographic point layer. */
      g=(root.__smLiveGlobeState&&root.__smLiveGlobeState.globe)||g;
      root.__smLastRecent=publicRecent;
      root.__smLastActive=publicActive;root.__smRoutes=d.routes||[];
      if(Array.isArray(d.heat))root.__smHeatCells=d.heat;
      root.__smHeatCells=root.__smHeatCells||[];
      if(g&&!root.classList.contains('sm-bb-active')){setLifetimeLocationPoints(g,root.__smHeatCells,opt,d.routes);try{setLiveVisitorPulses(g,publicActive,root)}catch(e){}}
      if(Array.isArray(d.heat))root.__smVisits24h=visits24h(d.heat);
      renderPurchaseSignals(root,d&&d.purchases);
      if(g&&!root.classList.contains('sm-bb-active'))updateHeat(root,g,opt,[],[],root.__smHeatCells);
      if(!root.classList.contains('sm-bb-active'))try{if(g&&typeof g.labelsData==='function')g.labelsData([])}catch(e){}
      /* Purchases remain dashboard data; they do not animate or mutate the map. */
      root.dataset.smActiveVisitors=String(publicActive.length);
      root.dataset.smRecentVisitors=String(publicRecent.length);
      updateLiveStats(root,publicActive,publicRecent);
      renderSharedFeed(root,publicActive,publicRecent,'');
      window.__smMapLastData=Object.assign({},d,{active:publicActive,recent:publicRecent});
      document.dispatchEvent(new CustomEvent('sm:map-data',{detail:window.__smMapLastData}));
    }).catch(function(){if(!stopped)document.dispatchEvent(new CustomEvent('sm:map-unavailable'))}).finally(function(){inFlight=false})}
    function heartbeat(){if(stopped||!sessionId||document.hidden)return;post('/heartbeat',{session_id:sessionId},false).catch(function(){})}
    function sendView(){if(stopped||!sessionId)return;post('/view',{session_id:sessionId,current_view:currentViewLabel()},false).catch(function(){})}
    function leave(){if(!sessionId)return;post('/leave',{session_id:sessionId},true).catch(function(){});removePointKind(g,'visitor');removeRingKind(g,'visitor')}
    function resume(){if(!sessionId)return;heartbeat();sendView();removePointKind(g,'visitor');removeRingKind(g,'visitor')}
    function vis(){document.hidden?leave():resume()}
    function onPop(){setTimeout(sendView,40)}
    document.addEventListener('visibilitychange',vis);window.addEventListener('pagehide',leave);window.addEventListener('pageshow',resume);window.addEventListener('popstate',onPop);
    poll();
    post('/visit',{},false).then(function(d){if(stopped)return;sessionId=d&&d.session_id||null;root.__smActivitySessionId=sessionId;removePointKind(g,'visitor');removeRingKind(g,'visitor');if(sessionId){sendView();heartbeatTimer=setInterval(heartbeat,30000)}poll()}).catch(function(){});
    pollTimer=setInterval(poll,30000);
    root.__smActivityCleanup=function(){stopped=true;if(heartbeatTimer)clearInterval(heartbeatTimer);if(pollTimer)clearInterval(pollTimer);if(sessionId)post('/leave',{session_id:sessionId},true).catch(function(){});document.removeEventListener('visibilitychange',vis);window.removeEventListener('pagehide',leave);window.removeEventListener('pageshow',resume);window.removeEventListener('popstate',onPop);root.__smActivitySessionId=null;root.__smActivityCleanup=null};
  }

  function applyBoundaries(root,g,opt){
    Promise.all([load(WORLD),opt.showAdmin1===false?Promise.resolve({features:[]}):load(ADMIN),opt.showContinents===false?Promise.resolve({features:[]}):load(COAST)]).then(function(x){
      if(!root.__smLiveGlobeState||root.__smLiveGlobeState.globe!==g)return;
      var globeCfg=window.__smGlobeColorSettings||{},solid=globeCfg.solid!==false;
      var countries=(solid||opt.showCountryOutlines!==false)?mark(x[0].features,'country'):[];
      var admin=opt.showAdmin1===false?[]:mark(x[1].features,'admin');
      var coast=paths(x[2].features);
      root.__smBoundaryFeatures={countries:countries,admin:admin};
      var cc=opt.countryOutlineColor||opt.aqua,ac=opt.admin1Color||opt.aqua,tc=opt.continentColor||opt.aqua;
      try{
        g.polygonsData(countries.concat(admin))
         .polygonCapColor(function(f){
           var count=Number(f.__smHeatScore)||0,intensity=typeof opt.heatIntensity==='number'?opt.heatIntensity:.55;
           if(f.__smLayer==='admin'){
             if(opt.showHeatLayer!==false&&count>0)return rgba(heatColor(count,opt),Math.min(.48,.112+intensity*(.16+.32*Math.min(1,count/6))));
             return rgba(opt.landColor||'#120B0B',.16);
           }
           if(opt.showHeatLayer!==false&&count>0)return rgba(heatColor(count,opt),Math.min(.32,.064+intensity*(.112+.224*Math.min(1,count/8))));
           return rgba(opt.landColor||'#120B0B',.10);
         })
         .polygonSideColor(function(){return'rgba(0,0,0,0)'})
         .polygonStrokeColor(function(f){
           if(f.__smLayer==='admin')return rgba(ac,typeof opt.admin1Opacity==='number'?opt.admin1Opacity:.38);
           return opt.showCountryOutlines===false?'rgba(0,0,0,0)':rgba(cc,typeof opt.countryOutlineOpacity==='number'?opt.countryOutlineOpacity:.30)
         })
         .polygonAltitude(function(f){return f.__smLayer==='admin'?(typeof opt.admin1Lift==='number'?opt.admin1Lift:.009):(typeof opt.countryLift==='number'?opt.countryLift:.006)})
         .polygonLabel(function(f){return heatLabel(f)});
      }catch(e){}
      /* Coastline path layer removed so it cannot cover the Brooklyn beacon. Country and state polygons remain. */
      try{if(typeof g.pathsData==='function')g.pathsData([])}catch(e){}
      updateHeat(root,g,opt,[],[],root.__smHeatCells||[]);
    });
  }

  function installRefresh(root,g,opt){
    var btn=root.querySelector('[data-sm-map-refresh]');
    if(!btn){
      btn=document.createElement('button');
      btn.type='button';
      btn.className='sm-world-live__refresh';
      btn.setAttribute('data-sm-map-refresh','');
      btn.setAttribute('aria-label','Refresh live world map');
      btn.setAttribute('title','Refresh live map');
      btn.innerHTML='↻';
      var wrap=root.querySelector('.sm-world-live__globe-wrap')||root;
      wrap.appendChild(btn);
    }
    if(btn.dataset.smRefreshBound==='1')return;
    btn.dataset.smRefreshBound='1';
    btn.addEventListener('click',function(){
      if(btn.disabled)return;
      btn.disabled=true;
      btn.classList.add('is-refreshing');
      try{applyStarSetting(root,g);applyBoundaries(root,g,opt);installBrooklyn(g,opt);bindSharedGeo(root,g,opt);startActivity(root,g,opt)}catch(e){}
      document.dispatchEvent(new CustomEvent('sm:globe-colors-refresh'));
      setTimeout(function(){btn.disabled=false;btn.classList.remove('is-refreshing')},900);
    });
  }

  function install(root){
    if(!root)return;startActivity(root,null,settings(root));forceGlobalLabels(root);setTimeout(function(){forceGlobalLabels(root)},250);setTimeout(function(){forceGlobalLabels(root)},1200);
    function wait(){
      if(!document.documentElement.contains(root))return;
      var st=root.__smLiveGlobeState,g=st&&st.globe;
      if(!g){setTimeout(wait,250);return}
      try{g.onPointClick(function(p){if(p&&p.__smKind==='lifetime-location')document.dispatchEvent(new CustomEvent('sm:map-location',{detail:p}))})}catch(e){}
      var opt=settings(root);applyStarSetting(root,g);applyBoundaries(root,g,opt);installBrooklyn(g,opt);bindSharedGeo(root,g,opt);installRefresh(root,g,opt);installAmbientNetwork(root);root.dataset.smTruthfulOverlay='1';
      setLifetimeLocationPoints(g,root.__smHeatCells||[],opt,root.__smRoutes||[]);try{setLiveVisitorPulses(g,root.__smLastActive||[],root)}catch(e){}
    }
    wait();
  }

  function scan(scope){(scope||document).querySelectorAll('[data-sm-world-live]').forEach(install)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){scan(document)});else scan(document);
  document.addEventListener('shopify:section:load',function(e){setTimeout(function(){scan(e.target)},80)});
  document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('[data-sm-world-live]').forEach(function(root){if(root.__smSharedGeoCleanup)root.__smSharedGeoCleanup();if(root.__smActivityCleanup)root.__smActivityCleanup();if(root.__smAmbientCleanup)root.__smAmbientCleanup()})});
})();
